import * as React from 'react';

export function useKeyPress(
  key: string,
  callback?: (ev: KeyboardEvent) => void,
  targetRef?: React.RefObject<HTMLElement>
) {
  React.useEffect(() => {
    // We want to target a specific element but it is not yet mounted
    if (targetRef && !targetRef.current) {
      return;
    }

    if (!callback) {
      return;
    }

    const handleKeyPress = (ev: KeyboardEvent) => {
      if (ev.key === key) {
        callback(ev);
      }
    };

    const target = targetRef?.current || window;

    target.addEventListener('keydown', handleKeyPress);

    return () => {
      target.removeEventListener('keydown', handleKeyPress);
    };
  }, [targetRef, key, callback]);
}
